<template>
<b-form @submit.prevent="findUser">
  <b-form-group label="Username:" label-for="uid" label-cols-sm="3">
    <b-form-input v-model="username" placeholder="Username" required id="uid" :state="searchState" />
  </b-form-group>
  <b-form-invalid-feedback>{{errorMsg}}</b-form-invalid-feedback>
  <div class="form-footer">
    <b-button variant="primary" type="submit" :disabled="loading" class="float-right">
      Find user
      <b-spinner small v-if="loading"></b-spinner>
      <span class="sr-only" v-if="loading">Loading...</span>
    </b-button>
  </div>
</b-form>
</template>

<script>
export default {
  name: 'FindUser',
  data() {
    return {
      username: null
    }
  },
  computed: {
    errorMsg() { return this.$store.state.findUserError; },
    loading() { return this.$store.state.findUserLoading; },
    searchState() {
      if (this.errorMsg) {
        return false;
      }
      return null;
    }
  },
  mounted() {
    this.username = null;
  },
  methods: {
    findUser() {
      this.$store.dispatch('findUser', this.username);
    }
  }
}
</script>
